/**
 * Cycle Header
 *
 * Placeholder component for cycle information header.
 */

import { View } from "react-native";

export function CycleHeader() {
  return <View />;
}
